import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { CourseSummaryDTO } from "src/app/data/schema/Courses/CourseSummaryDTO";
import { CourseService } from "src/app/modules/courses/services/course.service";
import { PresentationService } from "src/app/modules/courses/services/presentation.service";

@Component({
    selector: "app-profile-review-list",
    templateUrl: "./profile-review-list.component.html",
    styleUrls: ["./profile-review-list.component.scss"]
})
export class ProfileReviewListComponent implements OnInit, OnDestroy {
    private coursesSubscription: Subscription;

    public isLoading$: Observable<boolean>;
    public courses: CourseSummaryDTO[];
    public hasCourses: boolean;

    constructor(private courseService: CourseService, private presentationService: PresentationService) {
        this.isLoading$ = this.courseService.getLoading();

        this.coursesSubscription = this.courseService.getCoursesForRevisionAsync().subscribe((courses) => {
            if (courses) {
                this.courses = courses;

                if (this.courses != undefined && this.courses.length > 0) {
                    this.hasCourses = true;
                } else {
                    this.hasCourses = false;
                }
            } else {
                this.hasCourses = false;
            }
        });
    }

    ngOnInit(): void {
        this.presentationService.getLoggedUser();
        this.courseService.fetchCoursesForRevision();
    }

    ngOnDestroy(): void {
        this.coursesSubscription.unsubscribe();
        this.courseService.clear();
        this.presentationService.clear();
    }

    public subscribeCourse = (courseId: string): void => {
        this.presentationService.subscribeCourseById(courseId);
    };
}
